import { extend, $$, addEvent, $ } from './helper-functions'

export class ButtonBurger {
  constructor (settings, selectors, classes) {
    this.settings = extend({}, settings)

    this.selectors = extend({
      block: '.button--burger',
      blockActive: '.button--burger.button--active',
      page: '.page'
    }, selectors)

    this.classes = extend({
      block: 'button--burger',
      active: 'button--active',
      pageBlur: 'page--blur-content-footer'
    }, classes)
  }

  init () {
    this.$burgerButtons = $$(this.selectors.block)
    this.events()
  }

  events () {
    const that = this

    that.$burgerButtons.forEach((burgerButton) => {
      addEvent(burgerButton, 'click', () => {
        burgerButton.classList.toggle(that.classes.active)
      })
    })

    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        that.$burgerButtons.forEach((burgerButton) => {
          burgerButton.classList.remove(that.classes.active)
        })
      }
    })

    addEvent(window, 'resize', () => {
      if (window.innerWidth > 1024 && $$(that.selectors.blockActive).length > 0) {
        $(that.selectors.page).classList.remove(that.classes.pageBlur)
        that.$burgerButtons.forEach((burgerButton) => {
          burgerButton.classList.remove(that.classes.active)
        })
      }
    })
  }
}

export default ButtonBurger
